import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import speakAloudImg from "../../assets/speak_aloud_img.svg";
import micQualityImg from "../../assets/mic_quality_img.svg";
import "./QualityChecksInstruction.css";
import AudioQualityComponent from "./AudioQualityComponent/AudioQualityComponent";

function QualityChecksInstruction({
  headingText,
  borderColor,
  headingColor,
  contentColor,
  border,
  boxShadow,
  t,
}) {
  return (
    <div
      style={{
        borderRadius: "16px",
        border: `${border} solid ${borderColor}`,
        boxShadow: `${boxShadow}`,
      }}
      className="container"
    >
      <div
        style={{
          color: `${headingColor}`,
        }}
        className="instruction-heading"
      >
        {headingText}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "22px",
          marginTop: "24px",
        }}
      >
        <AudioQualityComponent
          icon={<VolumeOffIcon />}
          text={t("no_noice")}
          iconColor="#A2C357"
          contentColor={contentColor}
        />
        <AudioQualityComponent
          icon={
            <img
              src={micQualityImg}
              style={{
                width: "20px",
              }}
              alt="mic-quality"
            />
          }
          text={t("mic_quality")}
          contentColor={contentColor}
        />
        <AudioQualityComponent
          icon={<img src={speakAloudImg} alt="speak-aloud" />}
          text={t("speak_aloud")}
          contentColor={contentColor}
        />
      </div>
    </div>
  );
}

export default QualityChecksInstruction;
